import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Output, ViewChild } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { OrderService } from "../order.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { VoucherKindInfo } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { SaleMethodBranchModel, SaleMethodNature } from "../../sales/model/sale-method-branch.model";
import { debounceTime, delay, take, takeUntil, tap } from "rxjs/operators";
import { FastAccessEnum } from "../model/fastaccessenum";
import { ActivePageEnum } from "../model/activepage.enum";
import { Branch, Lookup, User } from "projects/sepidz-web-framework/src/lib/models";
import { LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { OrderSettingModel, OrderSizeModel } from "../model/ordersetting.model";
import { SalonOrderService } from "../salonorder/salonorder.service";
import { ItemOrderService } from "./item/itemorder.service";
import { InvoiceService } from "./invoice/invoice.service";
import { FastAccessService } from "./fastaccess/fastaccess.service";
import { CommonService } from "projects/sepidz-web-framework/src/lib/services/common.service";
import { InvoiceActionService } from "../providers/invoiceaction.service";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { CustomerOrderService } from "../customerorder/customerorder.service";
import { PaymentMethodLookUp } from "../model/payment.lookup";
import { Personnel } from "../../parties/model/personnel.model";
import { AngularResizeElementEvent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/resizable/angular-resize-element-event.interface";
import { AngularResizeElementDirection } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/resizable/angular-resize-element.enum";
import { TotalPriceService } from "./invoice/totalprice/totalprice.service";
import { DriverAssignementService } from "../../driverassignment/driverassignment.service";
import { Customer } from "../../parties/model/customer.model";
import { ChangeCachEnum } from "../model/changecach.enum";
import { ClearableCache } from "../../../../../projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { InvoicePrintService } from "../providers/invoiceprint.service";
import { OrderSizeEnum } from "../model/orderSize.enum";
import { BarCodeReaderFormat } from "src/app/gnr/bar-code-reader-format/bar-code-reader-format.model";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { InvDailyWarehouse } from "../../inv/model/inv-daily-warehouse.model";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";
import { ItemStateEnum, InvoiceStatus } from "../model/invoice.model";
import { NotificationModel } from "projects/sepidz-web-framework/src/lib/models/notification-model";
import { InvoicesComponent } from "../invoices/invoices.component";
import { WebKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { SoftWareLicenseKind } from "projects/sepidz-web-framework/src/lib/models/license-information.model";
import { PosScaleService } from "../providers/pos-scale.service";
import { LocalSettingKind } from "../../local-setting/local-setting-model";

@Component({
  selector: "app-order",
  templateUrl: "./orderpage.component.html",
  styleUrls: ["./orderpage.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    InvoiceActionService,
    OrderService,
    TotalPriceService,
    ItemOrderService,
    InvoiceService,
    FastAccessService,
    SalonOrderService,
    CustomerOrderService,
    DriverAssignementService,
    InvoicePrintService,
    PosScaleService,
  ],
})
export class OrderPageComponent extends BaseListComponent {
  @ViewChild("invoices") invoicesElement: InvoicesComponent;
  public readonly AngularResizeElementDirection = AngularResizeElementDirection;
  public data: any = {};
  //ای دی نحوه فروش
  saleMethodBranchId: number;
  // دسترسی انتخاب شده
  selectedFastAccess: FastAccessEnum;
  // ماهیت فروش برای تب جاری
  saleMethodNature: typeof SaleMethodNature = SaleMethodNature;
  // تنظیمات مربوط به نحوه فروش
  saleMethodBranchModel: SaleMethodBranchModel;
  selectedWaiterFastAccess: boolean;
  selectedCustomerFastAccess: boolean;
  @Output() onShortKey: EventEmitter<null> = new EventEmitter();
  currentInvoicesFilter: any;

  constructor(
    public order: OrderService,
    public common: CommonService,
    public invoiceAction: InvoiceActionService,
    private tabsservice: TabularService,
    public lookupservice: LookupService,
    public totalService: TotalPriceService,
    public invoiceservice: InvoiceService,
    __id: FormContainerModel,
    private splashFormService: SplashFormService,
    public cd: ChangeDetectorRef,
    private invoicePrint: InvoicePrintService,
    _VoucherKIndInfo: VoucherKindInfo,
    private notification: NotificationService,
    private salonService: SalonOrderService
  ) {
    super();
    this.order.orderOnlinePage = _VoucherKIndInfo["orderOnlinePage"];
    this.order.autoDelinoInvoiceId = _VoucherKIndInfo["autoDelinoInvoiceId"];
    if (this.order.orderOnlinePage) this.splashFormService.openDialog("", " ");

    this.NoLog = true;
    this.setUserSystemLog();
    //__id ای دی تب مرتبط با فرم
    //_VoucherKIndInfo; ای دی نحوه فروش
    //_tabsservice;  سرویس تب در صورت نیاز می توان با ای دی دریافتی و سرویس تب تب جاری بست
    this.order.invoice.SaleMethodBranchId = _VoucherKIndInfo.VoucherKindId;

    this.saleMethodBranchId = _VoucherKIndInfo.VoucherKindId;
    this.order.invoice.SaleMethodBranchId = this.saleMethodBranchId;

    this.currentTabId = __id.metadata.id;
    this.order.cd = this.cd;
    this.order.tabsservice = this.tabsservice;
    this.order.isLight = order.currentInformation.SepidzWebKind === SoftWareLicenseKind.RestaurantLightWeb;
  }

  ngOnInit() {
    this.init();
    this.GetCachState();
    this.getWarehouseStock();
    this.checkHasPosScale();
  }
  getWarehouseStock() {
    const isLight = this.order.currentInformation.SepidzWebKind === SoftWareLicenseKind.RestaurantLightWeb;
    if (isLight) return;
    this.order.indexedDbService.get("FrontOffice", "InvDaily").then((data) => {
      if (data && data.length) {
        const branchId = this.getCurrentBranchId();
        this.order.warehouseStockItems = data;
        this.order.setDailyInventoryList(branchId);
      } else this.loadWareHouseStockItems();
    });
  }

  GetCachState() {
    this.splashFormService.openDialog("", " ");
    const computerName: string = this.order.storage.getData(ClearableCache.ComputerName);
    this.httpCommonService
      .get(`LocalSetting/GetCachState` + (computerName ? "?ComputerName=" + computerName : ""))
      .pipe(take(1))
      .subscribe((data: any[]) => {
        localStorage.setItem("cacheState", JSON.stringify(data));
        if (data) {
          this.order.changeCachEnum = data;
          this.invoiceAction.invoicePrint = this.invoicePrint;
          this.invoicePrint.changeCachEnum = data;
        }
        this.GetAllDataAfterSaleMethod();
        this.GetFirstData();
      });
  }

  /* گرفتن نحوه فروش به همراه اطلاعاتی که به نحوه فروش وابستگی ندارد */
  GetFirstData() {
    const data = this.order.storage.getData(ClearableCache.SaleMethodBranch);
    if (this.order.changeCachEnum.some((f) => f === ChangeCachEnum.SaleMethod) && data?.length) {
      this.order.saleMethodList = data;
      this.order.saleMethodBranch = data.find((f) => f.Id == this.saleMethodBranchId);
      this.order.changeSaleMethodBranch = this.order.saleMethodBranch;
      this.order.currentSaleMethodNature = this.order.saleMethodBranch.SaleMethod.SaleMethodNatureCode;
      this.order.oldSaleMethodBranchId = this.saleMethodBranchId;
      this.getDelinoWebId();
      this.order.formGroupControl();
      this.order.setInvoiceHasFactorAndHasPaymentLink();
      this.order.checkPermissions();
      this.getBarcodeReaderFormat();
      this.order.setActivePage();
      if (!this.order.currentUser) {
        this.httpCommonService
          .get("Authorization/CurrentUser/" + this.accountService.authService.currentUser.Id)
          .pipe(take(1))
          .subscribe(
            (data: User) => {
              this.order.currentUser = data;
              localStorage.setItem("current_User_Info", JSON.stringify(data));
              if (this.order.saleMethodBranch.WaiterIsRequired) this.getWaiters();
            },
            (err) => {
              console.log(err);
            }
          );
      } else if (this.order.saleMethodBranch.WaiterIsRequired) this.getWaiters();
    } else {
      const computerName = this.order.storage.getData(ClearableCache.ComputerName);
      this.httpCommonService
        .get("SaleMethodBranch/GetAllSaleMethodBranch" + (computerName ? "?ComputerName=" + computerName : ""))
        .pipe(take(1))
        .subscribe((data: SaleMethodBranchModel[]) => {
          this.order.saleMethodBranch = data.find((f) => f.Id == this.saleMethodBranchId);
          this.order.saleMethodList = data;
          this.order.changeSaleMethodBranch = this.order.saleMethodBranch;
          this.order.currentSaleMethodNature = this.order.saleMethodBranch?.SaleMethod?.SaleMethodNatureCode;
          this.order.oldSaleMethodBranchId = this.saleMethodBranchId;
          this.order.formGroupControl();
          this.getDelinoWebId();
          this.order.storage.savePermanentData(data, ClearableCache.SaleMethodBranch);
          this.getBarcodeReaderFormat();
          this.order.setInvoiceHasFactorAndHasPaymentLink();
          this.order.checkPermissions();
          this.order.setActivePage();
          if (!this.order.currentUser) {
            this.httpCommonService
              .get("Authorization/CurrentUser/" + this.accountService.authService.currentUser.Id)
              .pipe(take(1))
              .subscribe(
                (data: User) => {
                  this.order.currentUser = data;
                  localStorage.setItem("current_User_Info", JSON.stringify(data));
                  if (this.order.saleMethodBranch.WaiterIsRequired) this.getWaiters();
                },
                (err) => {
                  console.log(err);
                }
              );
          } else if (this.order.saleMethodBranch.WaiterIsRequired) this.getWaiters();
        });
    }

    this.getLookUp();
    this.getBranch();
    this.getDefultCustomer();
    this.getSetting();
  }

  GetAllDataAfterSaleMethod() {
    this.order.getMaxInvoiceCode(this.order.logInBranch.Id, true, true);
    if (!this.order.orderOnlinePage) this.splashFormService.closeLoading();
  }

  checkHasPosScale() {
    const computerName: string = this.order.storage.getData(ClearableCache.ComputerName);
    const localSetting = this.order.storage
      .getData(ClearableCache.LocalSetting)
      .find((x) => x.LocalSettingKindCode === LocalSettingKind.PosScale && x.ComputerName === computerName);
    this.order.hasPosScale =
      localSetting !== null && localSetting?.Ip && localSetting?.Port && this.order.accountService.authService.currentBranch.HasDecimal;
    if (this.order.hasPosScale) {
      this.order.posScaleService.Url = `http://${localSetting.Ip}:${localSetting.Port}/api/PosScale`;
      this.order.posScaleService.connect().subscribe({
        next: () => {
          this.order.splashFormService.openDialog("", "درحال اتصال با ترازو");
          this.order.posScaleService.connection().subscribe({
            next: (res: any) => {
              this.order.posScaleService.isConnected = res.isConnected;
              if (res.isConnected) this.sts.showToast("success", "", "اتصال با ترازو برقرار شد.", 5000);
              else this.sts.showToast("danger", "", res.Message, 5000);
              this.order.splashFormService.closeLoading();
              this.cd.markForCheck();
              this.order.detectChanges();
            },
            error: (err) => {
              this.order.splashFormService.closeLoading();
            },
          });
        },
        error: () => {
          this.sts.showDialog("مشکل در برقراری اتصال با لوکال سرویس", "خطا");
        },
      });
    }
  }

  //گرفتن لیست شابلون بارکد
  getBarcodeReaderFormat() {
    if (this.order?.barCodeReaderFormat) return;
    this.httpCommonService
      .getList("BarCodeReaderFormat")
      .pipe(take(1))
      .subscribe((data: BarCodeReaderFormat[]) => {
        if (data.length > 0) {
          this.order.barCodeReaderFormat = data;
        }
        localStorage.setItem("BarCodeReaderFormat", JSON.stringify(data));
      });
  }

  //گرفتن گارسون ها
  getWaiters() {
    if (this.order?.waiters?.length > 0) return;
    this.httpCommonService
      .getList("Personnel/GetWaiterList")
      .pipe(take(1))
      .subscribe((data: Personnel[]) => {
        if (data.length > 0) {
          this.order.waiters = data;
          const fidUserGarson = data.find((f) => f.UserId === this.order.currentUser?.Id);
          if (fidUserGarson) {
            this.order.invoice.WaiterId = fidUserGarson?.Id;
            this.order.invoice.WaiterName = fidUserGarson.DisplayName;
            this.order.waiterMobile = fidUserGarson.DisplayName;
            this.order.waiterId = fidUserGarson?.Id;
          }
        }
      });
  }

  public getLookUp() {
    this.lookupservice
      .getLookupbyCategory("SALE", "InvoiceStatus")
      .pipe(take(1))
      .subscribe((lookups) => {
        this.order.invoiceStatusLookups = JSON.parse(JSON.stringify(lookups));
      });
    this.lookupservice
      .getLookupbyCategory("SALE", "InvoiceChanges")
      .pipe(take(1))
      .subscribe((lookups) => {
        this.order.invoiceChangesLookups = lookups;
      });
    this.lookupservice
      .getLookupbyCategory("SALE", "InvoiceCommand")
      .pipe(take(1))
      .subscribe((lookups) => {
        this.order.invoiceCommandLookups = lookups;
      });
    this.lookupservice
      .getLookupbyCategory("SALE", "InvoicePayableChange")
      .pipe(take(1))
      .subscribe((lookups) => {
        this.order.invoicePayableChangeLookups = lookups;
      });
    this.lookupservice
      .getLookupbyCategory("SALE", "ReceiptPaymentType")
      .pipe(take(1))
      .subscribe((lookups) => {
        this.order.receiptPaymentTypeLookup = lookups;
      });

    this.order.paymentMethodTypeLookup = this.order.storage.getData(ClearableCache.PaymentMethodLookUp);
    if (this.order.changeCachEnum.some((f) => f === ChangeCachEnum.paymentMethodType) && this.order.paymentMethodTypeLookup != null) {
    } else {
      const computerName: string = this.order.storage.getData(ClearableCache.ComputerName);
      this.httpCommonService
        .getList("PaymentMethod/PaymentMethodLookUp" + "/" + this.order.logInBranch.Id + (computerName ? "?ComputerName=" + computerName : ""))
        .pipe(take(1))
        .subscribe((data: PaymentMethodLookUp[]) => {
          this.order.paymentMethodTypeLookup = data;
          this.order.storage.savePermanentData(data, ClearableCache.PaymentMethodLookUp);
        });
    }

    this.lookupservice
      .getLookupbyCategory("SALE", "NumberType")
      .pipe(take(1))
      .subscribe((lookups) => {
        this.order.PhoneTypeLookup = lookups;
      });
  }

  // دریافت شعبه فروش
  async getBranch() {
    const currentBranchId = this.order.logInBranch.Id;
    this.order.Branches = this.order.storage.getData(ClearableCache.Branches);
    if (this.order.changeCachEnum.some((f) => f === ChangeCachEnum.Branches) && this.order.Branches != null) {
      this.order.currentBranch = this.order.Branches.find((f) => f.Id === currentBranchId);
      this.invoicePrint.currentBranch = Object.assign({}, this.order.currentBranch);
      this.invoiceAction.invoicePrint = this.invoicePrint;
      this.invoicePrint.PreData();
      this.order.storage.savePermanentData(this.order.Branches, ClearableCache.Branches);

      if (this.order.currentInformation.RestaurantCallCenter) {
        this.setCallCenterLookup();
        this.order.RestaurantCallCenter = true;
      }
    } else {
      const computerName: string = this.order.storage.getData(ClearableCache.ComputerName);
      this.httpCommonService
        .getList("Branch/GetAllBranch" + (computerName ? "?ComputerName=" + computerName : ""))
        .pipe(take(1))
        .subscribe(
          async (data: Branch[]) => {
            this.order.Branches = data;
            this.order.Branches = this.order.Branches.filter((x) => !x.AccessToAllBranches);
            if (data?.length > 0 && this.order.currentInformation.RestaurantCallCenter) {
              if (!this.order.CallCenterLookUp) {
                this.order.CallCenterLookUp = [];
              }
              this.setCallCenterLookup();
              this.order.RestaurantCallCenter = true;
            }
            this.order.currentBranch = data.find((f) => f.Id === currentBranchId);
            this.invoicePrint.currentBranch = Object.assign({}, this.order.currentBranch);
            this.invoiceAction.invoicePrint = this.invoicePrint;
            this.invoicePrint.PreData();
            this.order.storage.savePermanentData(data, ClearableCache.Branches);
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  //تغییر فیلد نمایش یا عدم نمایش صفحه گارسون ها در دسترسی سریع
  ChangeShowWaiterFastAccess(event) {
    if (event === FastAccessEnum.Waiter) {
      this.selectedWaiterFastAccess = true;
    } else {
      this.selectedWaiterFastAccess = false;
    }
  }

  //تغییر فیلد نمایش یا عدم نمایش صفحه مشترکین در دسترسی سریع
  ChangeShowCustomerFastAccess(event) {
    if (event === FastAccessEnum.Customer) {
      this.selectedCustomerFastAccess = true;
    } else {
      this.selectedCustomerFastAccess = false;
    }
  }

  onResize(event) {
    if (window.screen.width > 993) {
      if (
        this.order.currentActivePage === this.order.activePageEnum.OrderItem ||
        this.order.currentActivePage === this.order.activePageEnum.Invoice
      ) {
        this.order.currentActivePage = ActivePageEnum.Order;
      }
    }
    if (window.screen.width < 993) {
      if (this.order.currentActivePage === this.order.activePageEnum.Order) {
        this.order.currentActivePage = ActivePageEnum.OrderItem;
      }
    }
    this.order.detectChanges();
  }

  @HostListener("document:keydown", ["$event"]) onKeydownHandler($event: KeyboardEvent) {
    if (document.hidden || this.tabsservice.selectedTabId !== this.currentTabId) return;
    //this.onShortKey.emit($event);
    if (($event.key === "*" || $event.key === "F2") && this.order.actionState.temporaryRegister) {
      this.invoiceAction.SaveInvoice(this.invoiceAction.invoiceCommand.TemporaryRegister, this.order.invoice, null, this.invoiceservice.order);
      $event.preventDefault();
    }
    if (/*$event.key === "-" ||*/ $event.key === "F1") {
      if (
        (this.order.currentSaleMethodNature === SaleMethodNature.Restaurant || this.order.currentSaleMethodNature === SaleMethodNature.Delivery) &&
        this.order.actionState.preparationPrint
      ) {
        this.invoiceAction.SaveInvoice(this.invoiceAction.invoiceCommand.PreparationPrint, this.order.invoice, null, this.order);
        $event.preventDefault();
      }
      if (this.order.currentSaleMethodNature === SaleMethodNature.FastFood && this.order.actionState.clear) {
        this.invoiceAction.SaveInvoice(this.invoiceAction.invoiceCommand.Clear, this.order.invoice, null, this.order);
        $event.preventDefault();
      }
    }
    if ($event.key === "F3") {
      this.order.OrderSetting.showComplate = !this.order.OrderSetting.showComplate;
      this.common.updateSettings(this.order.OrderSetting);
      $event.preventDefault();
      setTimeout(() => this.order.detectChanges(), 50);
    }
    if ($event.key === "F4") {
      this.invoiceservice.changeQuantity(null, ItemStateEnum.Clear);
      $event.preventDefault();
    }
    if ($event.key === "F6") {
      this.invoiceAction.focus("Description");
      $event.preventDefault();
    }
    if ($event.key === "F7") {
      this.order.OrderSetting.IsShowDescriptionBox = true;
      this.common.updateSettings(this.order.OrderSetting);
      $event.preventDefault();
    }
    if ($event.key === "F8") {
      this.order.selectedFastAccess = FastAccessEnum.Invoice;
      this.order._opened = true;
      $event.preventDefault();
      this.order.cd_FastAccess.markForCheck();
    }
    if ($event.key === "F9") {
      this.order.setActivePage(ActivePageEnum.Invoices);
      $event.preventDefault();
    }
    if ($event.key === "F10") {
      this.order.setActivePage(ActivePageEnum.Invoices);
      this.currentInvoicesFilter = {
        key: 2,
        title: this.translate("ClientApp.FrontOffice.Order.OrderPage.Temporary"),
        count: 0,
        selected: false,
        value: InvoiceStatus.Pending,
      };
      $event.preventDefault();
    }
    if ($event.key === "F11" && this.order.currentSaleMethodNature === SaleMethodNature.Delivery) {
      this.order.setActivePage(ActivePageEnum.Invoices);
      this.currentInvoicesFilter = {
        key: 5,
        title: this.translate("ClientApp.FrontOffice.Order.OrderPage.NotAssigned"),
        count: 0,
        selected: false,
        value: InvoiceStatus.Ordering,
      };
      $event.preventDefault();
    }

    if ($event.key === "Escape") {
      this.order.newInvoice();
      $event.preventDefault();
    }
  }

  public Resize(evt: AngularResizeElementEvent): void {
    this.data.width = evt.currentWidthValue;
    this.data.height = evt.currentHeightValue;
    this.data.top = evt.currentTopValue;
    this.data.left = evt.currentLeftValue;
  }

  resizeEnd(evt: AngularResizeElementEvent) {
    const ordersize = new OrderSizeModel();
    ordersize.width = evt.currentWidthValue;
    ordersize.height = evt.currentHeightValue;
    ordersize.top = evt.currentTopValue;
    ordersize.left = evt.currentLeftValue;
    ordersize.key = OrderSizeEnum.OrderPage;
    ordersize.saleBranchId = this?.order?.saleMethodBranch?.Id;
    if (!this.common.LocalSetting.OrderSetting) this.common.LocalSetting.OrderSetting = new OrderSettingModel();
    if (!this.common?.LocalSetting?.OrderSetting?.OrderSize) {
      this.common.LocalSetting.OrderSetting.OrderSize = [];
    }
    const index = this.common.LocalSetting.OrderSetting.OrderSize.findIndex(
      (f) => f.key === OrderSizeEnum.OrderPage && f.saleBranchId === this?.saleMethodBranchId
    );
    if (index < 0) {
      this.common.LocalSetting.OrderSetting.OrderSize.push(ordersize);
    } else {
      this.common.LocalSetting.OrderSetting.OrderSize[index] = ordersize;
    }
    this.common.updateSettings();
  }

  //دریافت تنظیمات نمایشی
  getSetting() {
    this.order.OrderSetting = this.common.LocalSetting?.OrderSetting;
    if (this.common.isMobileMode) this.order.OrderSetting.IsShowDescriptionBox = false;
    const evt = this.order?.OrderSetting?.OrderSize?.find((f) => f.key === OrderSizeEnum.OrderPage && f.saleBranchId === this?.saleMethodBranchId);
    if (evt) {
      this.data.width = evt.width;
      this.data.height = evt.height;
      this.data.top = evt.top;
      this.data.left = evt.left;
      this.order.saleMethodBranch.Id = evt.saleBranchId;
    }
    this.cd.markForCheck();
  }

  getDefultCustomer() {
    if (!(this.order.invoice.CustomerId !== 0) || !this.order.invoice.CustomerId) {
      //دریافت اطلاعات مشتری پیش فرض
      const customer: Customer = this.order.storage.getData(ClearableCache.GetDefalultCustomer);
      if (customer) {
        this.order.customer = customer;
        this.order.DefultCustomer = customer;
        this.order.invoice.Customer = customer;
        this.order.invoice.CustomerNumber = customer.Party.Number;
        this.order.invoice.CustomerLastName = customer?.Party?.LastName;
        this.order.invoice.CustomerDisplayName = customer?.Party?.DisplayName;
        this.order.defaultCustomerId = this.order.invoice.CustomerId = customer.Id;
        this.order.invoice.CustomerId = this.order.invoice?.Customer?.Id;
        this.order.invoice.AddressId = customer?.Addresses[0]?.Id;
        this.order.invoice.CustomerAddress = customer?.Addresses?.find((f) => f.IsDefault);
        this.order.invoice.PhoneId = customer?.Numbers.length > 0 ? customer?.Numbers[0]?.Id : null;
        this.order.invoice.PhoneNumber = customer?.Numbers?.find((n) => n.IsDefault)?.Number;
        this.order.detectChanges();
        return;
      }
      this.httpCommonService
        .get("Customer/GetDefalultCustomer")
        .pipe(take(1))
        .subscribe((customer: Customer) => {
          if (customer) {
            this.order.customer = customer;
            this.order.DefultCustomer = customer;
            this.order.invoice.Customer = customer;
            this.order.invoice.CustomerNumber = customer.Party.Number;
            this.order.invoice.CustomerLastName = customer?.Party?.LastName;
            this.order.invoice.CustomerDisplayName = customer?.Party?.DisplayName;
            this.order.defaultCustomerId = this.order.invoice.CustomerId = customer.Id;
            this.order.invoice.CustomerId = this.order.invoice?.Customer?.Id;
            this.order.invoice.AddressId = customer?.Addresses[0]?.Id;
            this.order.invoice.CustomerAddress = customer?.Addresses?.find((f) => f.IsDefault);
            this.order.invoice.PhoneId = customer?.Numbers.length > 0 ? customer?.Numbers[0]?.Id : null;
            this.order.invoice.PhoneNumber = customer?.Numbers?.find((n) => n.IsDefault)?.Number;
            this.order.storage.savePermanentData(customer, ClearableCache.GetDefalultCustomer);
          } else {
            this.sts.showToast(
              "danger",
              this.translate("ClientApp.FrontOffice.Order.OrderPage.ErrorMessage"),
              this.translate("ClientApp.FrontOffice.Order.OrderPage.ClientDoesNotExist")
            );
          }
        });
    }
  }

  public refreshInvoicesGrid(ActivePage?: boolean) {
    if (this.order.currentActivePage == ActivePageEnum.Invoices || ActivePage) this.invoicesElement?.invoiceGrid?.refreshData();
  }

  public headerClickHandler(ActivePage: ActivePageEnum) {
    if (ActivePage == ActivePageEnum.Invoices) {
      this.refreshInvoicesGrid(true);
    }
    if (ActivePage == ActivePageEnum.Salon) {
      let salon = this.salonService.selectedSalons;
      this.salonService.getTablesRead(salon ? salon : this.salonService._salons[0]);
    }
  }

  private setCallCenterLookup(): void {
    const currentBranch = this.order.logInBranch;
    if (!this.order.isMultiBranch) {
      const lkp = new Lookup();
      lkp.Code = currentBranch.Code;
      lkp.Title = currentBranch.Title;
      lkp.Id = currentBranch.Id;
      this.order.CallCenterLookUp.push(lkp);
      this.order.setValue("BranchId", currentBranch.Id);
      this.order.invoice.BranchId = currentBranch.Id;
    } else {
      this.order.Branches.filter((x) => !x.Suspend && x.IsActive && !x.AccessToAllBranches).forEach((x) => {
        const lkp = new Lookup();
        lkp.Code = x.Code;
        lkp.Title = x.Title;
        lkp.Id = x.Id;
        this.order.CallCenterLookUp.push(lkp);
      });
    }
  }

  private async init() {
    this.notification.init();
    await this.notification.notification$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        tap(async (value) => {
          switch (value.Key) {
            case "ItemStockInWeb":
            case "ItemCategoryStockInWeb":
              this.order.indexedDbService.clear("FrontOffice", "Categories").then(() => {
                this.order.GetItemCategoryList();
              });
              break;
            case "UpdateWareHouseStock":
              this.updateInvoiceOnWareHouseChanges(value);
              this.refreshInvoicesGrid();
              break;
          }
        }),
        delay(1000)
      )
      .subscribe((value) => {
        if (value.Key === "InvoiceChanges") {
          const activePage = this.order.currentActivePage;
          if (activePage === ActivePageEnum.Invoices) this.refreshInvoicesGrid();
        }
      });
  }

  private updateInvoiceOnWareHouseChanges(value: NotificationModel): void {
    if (value.Message?.goodsInfo?.length) {
      let notAvailableGoods = "";
      let nearToNotAvailableGoods = "";
      const branchId = value.Message?.goodsInfo[0]?.BranchId;
      (value.Message?.goodsInfo as InvDailyWarehouse[]).forEach((newInfo) => {
        let goodsInfo = this.order.warehouseStockItems.find((x) => x.GoodsId == newInfo.GoodsId && x.BranchId === branchId);
        if (goodsInfo) {
          goodsInfo.Amount = newInfo.Amount;
          goodsInfo.MinAmount = newInfo.MinAmount;
          goodsInfo.WasteAmount = newInfo.WasteAmount;
          goodsInfo.PrevRemainAmount = newInfo.PrevRemainAmount;
          goodsInfo.EntryAmount = newInfo.EntryAmount;
          goodsInfo.CancelAmount = newInfo.CancelAmount;
          goodsInfo.SaleAmount = newInfo.SaleAmount;
          if (goodsInfo.Amount <= 0 && (goodsInfo.EntryAmount || goodsInfo.PrevRemainAmount)) {
            notAvailableGoods += goodsInfo.GoodsTitle + " - ";
          } else if (goodsInfo.Amount <= goodsInfo.MinAmount && (goodsInfo.EntryAmount || goodsInfo.PrevRemainAmount)) {
            nearToNotAvailableGoods += goodsInfo.GoodsTitle + " - ";
          }
        } else this.order.warehouseStockItems.push(newInfo);
      });
      const stockItems = JSON.stringify(this.order.warehouseStockItems);
      this.order.warehouseStockItems = JSON.parse(stockItems);
      this.order.indexedDbService.put("FrontOffice", "InvDaily", this.order.warehouseStockItems).then();
      this.order.setDailyInventoryList(branchId);
      this.order.filterItembyBranchId(branchId);
      this.order.updateStockInWebByInvSignal(branchId, this.order.warehouseStockItems, value.Message?.eventName);
      this.order.detectChanges();
      const activePage = this.order.currentActivePage;
      const canShowMessage = this.common.isMobileMode
        ? activePage === ActivePageEnum.OrderItem || activePage === ActivePageEnum.Invoice
        : activePage === ActivePageEnum.Order;
      if (canShowMessage) {
        if (notAvailableGoods)
          this.sts.showToast(
            "danger",
            `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Product")}: ${notAvailableGoods} ${this.translate(
              "ClientApp.FrontOffice.Order.OrderPage.Disappeared"
            )}`,
            "",
            7000
          );
        if (nearToNotAvailableGoods)
          this.sts.showToast(
            "warning",
            `${this.translate("ClientApp.FrontOffice.Order.OrderPage.Inventory")}: ${nearToNotAvailableGoods} ${this.translate(
              "ClientApp.FrontOffice.Order.OrderPage.LessThanMinimum"
            )}`,
            "",
            7000
          );
      }
      this.order.detectChanges();
    }
  }

  private loadWareHouseStockItems(): void {
    const branchId = this.order.invoice.BranchId || this.order.logInBranch.Id;
    this.httpCommonService
      .get("Invoice/GetWarehouseStockItems?branchId=" + branchId)
      .pipe(
        take(1),
        tap((res: InvDailyWarehouse[]) => {
          this.order.warehouseStockItems = res;
          this.order.indexedDbService.put("FrontOffice", "InvDaily", res).then();
          this.order.setDailyInventoryList(branchId);
        }),
        debounceTime(1000)
      )
      .subscribe(() => {
        if (!this.isMultiBranch && this.order.warehouseStockItems?.length && this.order.itemCategoryList) this.order.filterItembyBranchId(branchId);
      });
  }

  private getCurrentBranchId(): number {
    const info = this.order.currentInformation;
    const hasCallCenterLicence = info.BranchingAdvancedEnabled || info.BranchingLightEnabled || info.RestaurantCallCenter;
    let branchId = this.order.logInBranch.Id;
    if (hasCallCenterLicence && this.isMultiBranch && this.order.invoice.BranchId) branchId = this.order.invoice.BranchId;
    return branchId;
  }

  private getDelinoWebId() {
    if (this.order.saleMethodBranch.HasDelino) {
      this.lookupservice
        .getLookupbyCategory("SALE", "WebKind")
        .pipe(take(1))
        .subscribe((list) => {
          this.order.WebKinds = list;
        });
    }
  }
}
